var sizeChartsRelentless = {
        done: function () {
          var chart = document.querySelector('.swatch-size-chart');
          var heading = document.querySelector('.fit-guide__heading');
          if (chart && heading) {
            heading.after(chart);
            heading.parentNode.style.justifyContent = 'space-between';
            heading.parentNode.style.gap = '8px';
            chart.style.marginTop = '-5px';
          }
        }
      }